export default __webpack_public_path__ + "static/media/DPfb - 465_Santanu Biswas.9aedb69c.jpg";